var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var s = Object.getOwnPropertySymbols(e); for (r = 0; r < s.length; r++) o = s[r], t.includes(o) || {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (e.includes(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgYoutubeIcon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 144,
    height: 123,
    viewBox: "0 0 144 123",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    opacity: 0.1,
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M138.929 36.506C133.849 25.6111 127.917 15.4034 121.249 5.9331L121.909 6.92511C117.757 2.02645 111.602 -0.371984 105.607 0.508776L105.479 0.53352C100.394 1.37325 89.3883 5.66956 78.897 10.0975C66.3253 15.4144 54.4962 20.9304 54.4962 20.9304C54.4962 20.9304 14.7598 39.3902 6.09047 46.8793C1.47075 50.983 -0.648148 57.2395 0.400925 63.4462L0.435198 63.5694C1.54583 67.8674 2.87944 72.2703 4.40049 76.7018C5.73045 80.5494 7.21481 84.4294 8.82179 88.2986C13.0643 98.5166 18.2396 108.694 24.0828 118.189C26.2948 121.788 28.6033 125.295 30.9862 128.663L30.3175 127.652C34.4701 132.551 40.6248 134.949 46.6243 134.078L46.7425 134.058C57.9204 132.222 97.7351 113.656 97.7351 113.656C97.7351 113.656 137.435 95.1439 146.141 87.7075C150.756 83.5942 152.885 77.3333 151.826 71.1311L151.801 71.0034C149.163 60.9657 145.156 49.8601 140.076 38.9652L139.506 37.7686L138.929 36.506ZM72.6948 93.1304L54.1467 53.3539L96.5691 57.8254L72.6948 93.1304Z",
    fill: "#131217"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutubeIcon);
export default __webpack_public_path__ + "static/media/youtubeIcon.399f53faa6c42d0536f7cb72e46a94eb.svg";
export { ForwardRef as ReactComponent };